<template>
  <aside v-if="$route.name === ROUTES.HOME" class="navigation w-95">
    <p class="navigation__title">{{ $beet.options.footer.bottom.title }}</p>
    <nav class="navigation__links">
      <NavigationLink icon="target" :label="$beet.options.footer.bottom.positions"
                      :to="{name: ROUTES.HOME, hash: `#${HASHES.AVAILABLE_POSITIONS}`}"/>
    </nav>
  </aside>
</template>

<script>
import NavigationLink from '@/components/navigation/small/NavigationLink.vue'
import {UsesRoutesMixin} from '@/mixins'

export default {
  name: 'BottomBar',
  mixins: [UsesRoutesMixin],
  components: {NavigationLink},
  methods: {
    getFormLink(formKey) {
      const query = {}
      query[this.QUERY_KEYS['FORM']] = formKey

      return {name: this.ROUTES.HOME, query: query}
    }
  }
}
</script>